module.exports = __webpack_public_path__ + "img/tarj2-11.b6c0f12e.svg";